import { GET_FLASHCARD_DETAILS } from "./types";

// Fetch List of Flashcards
const falshcardEndpoint = "rest_get_flashcards.php";
export const getFlashcardsDetails = (params) => (dispatch, getState, Api) => {
  // FLAG-GETURL
  return Api.get(falshcardEndpoint + params).then((response) => {
    dispatch({
      type: GET_FLASHCARD_DETAILS,
      payload: response.data,
    });
    return response;
  });
};
